import { API_CREATE_POPUP_READ, POPUP_RFP_REPLACE_HIDE_ACTION, } from '../actions/PopupActions';
const INITIAL_STATE = {
    accessEvent: {},
    hideRfpReplace: false,
};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { meta, type }) => {
    switch (type) {
        case POPUP_RFP_REPLACE_HIDE_ACTION: {
            return Object.assign(Object.assign({}, state), { hideRfpReplace: true });
        }
        case API_CREATE_POPUP_READ: {
            return Object.assign(Object.assign({}, state), { accessEvent: Object.assign(Object.assign({}, state.accessEvent), { [meta.event]: true }) });
        }
        default: {
            return state;
        }
    }
};
